import React, { Component } from "react";
import { Card } from "material-ui/Card";
import { Flex } from "rebass";
import { GET_ONE } from "admin-on-rest";
import { cyan500 } from "material-ui/styles/colors";
import { ViewTitle } from "../../components";
import { RestClient } from "../../restClient";
import Collections from "./Collections";
import { HeaderTitleCollections } from "../styled";
import { CubeGrid } from "../../components/spinkit";

class ProductList extends Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      data: {},
      isLoading: true
    };
  }

  componentWillMount() {
    this.getCollections(this.props.match.params.id);
  }

  getCollections(paramsId) {
    RestClient(GET_ONE, "campaigns", { id: paramsId })
      .then(items => {
        if (items && items.data) {
          this.setState({
            data: items.data,
            isLoading: false
          });
        }
      })
      .catch(e => {
        // resolve([]);
        this.setState({
          isLoading: false
        });
      });
  }

  render() {
    const { data, isLoading } = this.state;
    if (isLoading) {
      return (
        <div
          style={{
            display: "flex",
            height: "100%",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <Flex justify={["center"]} align={["center"]}>
            <CubeGrid size={80} color={cyan500} />
          </Flex>
        </div>
      );
    }
    return (
      <div>
        <Card containerStyle={{ minHeight: 318 }}>
          <ViewTitle title={<HeaderTitleCollections {...this.props} />} />
          <Flex w={[1]} direction={["column"]} p={[1]}>
            {data &&
              data.collections &&
              data.collections.length > 0 &&
              data.collections.map((item, index) => (
                <Collections collectionId={item} key={index} />
              ))}
          </Flex>
        </Card>
      </div>
    );
  }
}

export default ProductList;



// WEBPACK FOOTER //
// ./src/campaigns/productlist/ProductLlist.js